import React from "react";
import styles from "./HowItWorksSection.module.css";
import { Container } from "../../common/Container";
import { howItWorksData } from "../../../data/tidePostData";
import { useIntersectionObserver } from "../../../hooks/useIntersectionObserver";
import clsx from "clsx";

const icons: Record<string, React.FC> = {
  search: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
    </svg>
  ),
  chart: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z" />
    </svg>
  ),
  bell: () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
    </svg>
  ),
};

export const HowItWorksSection: React.FC = () => {
  const [ref, isVisible] = useIntersectionObserver<HTMLElement>({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section id="how-it-works" className={styles.section} ref={ref}>
      <Container>
        <div className={clsx(styles.content, isVisible && styles.visible)}>
          <div className={styles.header}>
            <span className={styles.label}>How It Works</span>
            <h2 className={styles.title}>Simple as 1-2-3</h2>
            <p className={styles.subtitle}>
              Get accurate tide information in seconds
            </p>
          </div>

          <div className={styles.steps}>
            {howItWorksData.map((step, index) => {
              const IconComponent = icons[step.icon];
              return (
                <div key={step.step} className={styles.step}>
                  <div className={styles.stepNumber}>
                    <span>{step.step}</span>
                  </div>
                  <div className={styles.stepIcon}>
                    {IconComponent && <IconComponent />}
                  </div>
                  <h3 className={styles.stepTitle}>{step.title}</h3>
                  <p className={styles.stepDescription}>{step.description}</p>
                  {index < howItWorksData.length - 1 && (
                    <div className={styles.connector}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                        <path d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                      </svg>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};
